import React, { Component } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import {
    datePickerGenericFilter,
    enumLabelSort,
    hrGenericFilter,
    textGenericFilter,
    textAmountGenericFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    enumStringGenericFilter,
    multiGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    // TODO: add this FLV
    // PacClassicElectionFilterableListView,
    OfficialFilterableListView,
    PacClassicPacOrganizationFilterableListView,
    // TODO: add this FLV
    // PacClassicOrganizationFilterableListView,
    PacClassicPacTransactionFilterableListView,
    SupporterFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    PacClassicPacLimitTypeSelect,
    PacClassicPacReportCodeSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import {
    ContactSelect,
    OfficialSelect,
    PacClassicBankAccountSelect,
    PacClassicElectionSelect,
    PacClassicOrganizationSelect,
    PacClassicPacOrganizationSelect,
    PacClassicPacTransactionSelect,
    // TODO: add PacClassicBatch table
    // PacClassicBatchSelect,
} from "app/static/frontend/selects/containers/PieSelect"

// selectors
import { selectFilterValue } from "shared/search/selectors"

// helpers
import { isValidAmountString } from "shared/imports/sharedHelperFunctions"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

const createFilterComponent = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}

// PacClassicPacTransactionTypeFilterGroup
export const PacClassicPacTransactionTypeFilter = (props) => createFilterComponent(props)
PacClassicPacTransactionTypeFilter.defaultProps = {
    filterComponent: enumStringGenericFilter,
    enumItems: DjangIO.app.pac_classic.types.PacClassicTransactionType.region_supported_items(),
    filterKey: "transaction_type__in",
    sortBy: DjangIO.orderSort,
    uniqueFilterId: "pacClassicPacTransactionTypeFilter",
}

// copied (with modifications) from
// shared/search/containers/Filter/Filters.js createTransactionAmountFilter
// PacClassicPacTransactionAmountFilterGroup
export const createPacClassicPacTransactionAmountFilter = (args) => {
    const uniqueFilterId = `${args.quorumDataType.key}PacClassicPacTransactionAmountFilter`
    const transactionId = `${uniqueFilterId}MultiPieSelectTransaction`
    const dateGteId = `${uniqueFilterId}MultiDateAmountGte`
    const dateLteId = `${uniqueFilterId}MultiDateAmountLte`
    const dateNewContributorGteId = `${uniqueFilterId}MultiDateAmountNewContributorGte`
    const dateNewContributorLteId = `${uniqueFilterId}MultiDateAmountNewContributorLte`
    const labelAmountId = `${uniqueFilterId}LabelAmount`
    const amountGteId = `${uniqueFilterId}MultiNumberInputAmountGte`
    const amountLteId = `${uniqueFilterId}MultiNumberInputAmountLte`
    const bankAccountId = `${uniqueFilterId}MultiPieSelectBankAccount`
    const electionId = `${uniqueFilterId}MultiPieSelectElection`
    const methodTypeId = `${uniqueFilterId}MultiEnumMethodType`
    const batchId = `${uniqueFilterId}MultiPieSelectBatch`
    const referenceNumberId = `${uniqueFilterId}MultiNumberInputReferenceNumber`
    const payrollCycleId = `${uniqueFilterId}MultiEnumPayrollCycle`
    const hasContributedId = `${uniqueFilterId}SingleToggleHasContributed`
    const labelNewContributorId = `${uniqueFilterId}LabelNewContributor`
    const limitTypeId = `${uniqueFilterId}MultiEnumLimitType`
    const pacReportCodeId = `${uniqueFilterId}MultiEnumPacReportCodeType`
    const serializationKey = "generic"

    const getDefaultProps = () => {
        const getDisplayLabelExtraTransactionType = () => {
            if (
                [
                    DjangIO.app.models.QuorumDataType.person.value,
                    DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
                    DjangIO.app.models.QuorumDataType.pacc_election.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Disbursement"
            } else if (
                [
                    DjangIO.app.models.QuorumDataType.supporter.value,
                    DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Receipt"
            }
        }
        const DateGteFilter = class TransactionDatePickerStartFilter extends Component {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                displayLabel: "Date From",
                // filterKey: "transaction_date__gte",
                filterKey: "",
                isSubSubfilter: true,
                uniqueFilterId: dateGteId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const DateLteFilter = class TransactionDatePickerEndFilter extends Component {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                displayLabel: "Date To",
                // filterKey: "transaction_date__lte",
                filterKey: "",
                isSubSubfilter: true,
                uniqueFilterId: dateLteId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }
        const DateNewContributorGteFilter = class TransactionDateNewContributorPickerStartFilter extends Component {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                uniqueFilterId: dateNewContributorGteId,
                // filterKey: "transaction_date__gte",
                filterKey: "",
                displayLabel: "First Contribution",
                isSubSubfilter: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const DateNewContributorLteFilter = class TransactionDateNewContributorPickerEndFilter extends Component {
            static defaultProps = {
                filterComponent: datePickerGenericFilter,
                displayLabel: "Last Contribution",
                // filterKey: "transaction_date__lte",
                filterKey: "",
                isSubSubfilter: true,
                uniqueFilterId: dateNewContributorLteId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const AmountLabelFilter = class TransactionLabelFilter extends Component {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                displayLabel: "Total Amount",
                invisible: true,
                uniqueFilterId: labelAmountId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const AmountGteFilter = class TransactionAmountGreaterFilter extends Component {
            static defaultProps = {
                filterComponent: textAmountGenericFilter,
                errorMessage: "Please enter a valid number amount.",
                // filterKey: "amount__gte", (QuorumDataType.pacc_pac_transaction)
                // filterKey: "sum__gte", (all others)
                filterKey: "",
                isSubSubfilter: true,
                keyboardType: "numeric",
                placeholderText: "Min ($)",
                shouldSubmitOnChange: true,
                shouldValidateInput: true,
                uniqueFilterId: amountGteId,
                validateTextInput: isValidAmountString,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const AmountLteFilter = class TransactionAmountLessFilter extends Component {
            static defaultProps = {
                filterComponent: textAmountGenericFilter,
                errorMessage: "Please enter a valid number amount.",
                // filterKey: "amount__lte", (QuorumDataType.pacc_pac_transaction)
                // filterKey: "sum__lte", (all others)
                filterKey: "",
                isSubSubfilter: true,
                keyboardType: "numeric",
                placeholderText: "Max ($)",
                shouldSubmitOnChange: true,
                shouldValidateInput: true,
                uniqueFilterId: amountLteId,
                validateTextInput: isValidAmountString,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const BankAccountFilter = class TransactionBankAccountFilter extends Component {
            static defaultProps = {
                filterComponent: searchifySelectGenericFilter,
                dataTypeLabel: "Bank Account",
                displayLabel: "Bank Account",
                // filterKey: "pac_classic_bank_account_id__in",
                filterKey: "",
                selectComponent: PacClassicBankAccountSelect,
                uniqueFilterId: bankAccountId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const ElectionFilter = class ElectionFilter extends Component {
            static defaultProps = {
                filterComponent: searchifySelectGenericFilter,
                displayLabel: "Search Elections",
                // filterKey: "pac_classic_election_id__in",
                filterKey: "",
                // TODO: add this FLV
                // searchifyFLV: PacClassicElectionFilterableListView,
                selectComponent: PacClassicElectionSelect,
                uniqueFilterId: electionId,
                searchifyPermanentFilter: {
                    for_transactions: args.quorumDataType.value,
                },
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const MethodTypeFilter = class TransactionMethodTypeFilter extends Component {
            static defaultProps = {
                filterComponent: enumStringGenericFilter,
                displayLabel: "Payment Methods",
                enumItems: DjangIO.app.pac_classic.types.PacClassicTransactionMethodType.region_supported_items().sort(
                    DjangIO.orderSort,
                ),
                // filterKey: "transaction_method__in",
                filterKey: "",
                sortBy: DjangIO.orderSort,
                uniqueFilterId: methodTypeId,
            }
            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        // TODO: add PacClassicBatch table and update filter from text to PieSelect
        // const BatchFilter = class TransactionBatchAccountFilter extends Component {
        //     static get defaultProps() {
        //         return {
        //             filterComponent: searchifySelectGenericFilter,
        //             uniqueFilterId: batchId,
        //             filterKey: "",
        //             dataTypeLabel: "Batch",
        //             displayLabel: "Batch",
        //             selectComponent: PacClassicBatchSelect,
        //             // TODO: do we need a Batch flv? or only select?
        //             searchifyFLV: PacClassicBatchFilterableListView,
        //         }
        //     }

        //     render() {
        //         const FilterComponent = this.props.filterComponent
        //         return <FilterComponent {...this.props} />
        //     }
        // }

        const ReferenceNumberFilter = class TransactionReferenceNumberFilter extends Component {
            static defaultProps = {
                filterComponent: textGenericFilter,
                displayLabel: "Reference Number",
                // filterKey: "reference_number__in",
                filterKey: "",
                placeholderText: "Choose a reference #...",
                uniqueFilterId: referenceNumberId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const PayrollCycleFilter = class TransactionPayrollCycleFilter extends Component {
            static defaultProps = {
                filterComponent: enumStringGenericFilter,
                displayLabel: "Contact Payroll Frequency",
                enumItems: DjangIO.app.pac_classic.types.PacClassicPayrollCycleType.region_supported_items(),
                // filterKey: "pac_classic_pac_account__payroll_cycle__in",
                filterKey: "",
                sortBy: DjangIO.valueSort,
                uniqueFilterId: payrollCycleId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const getDisplayLabelHasContributed = () => {
            if (
                [
                    DjangIO.app.models.QuorumDataType.person.value,
                    DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
                    DjangIO.app.models.QuorumDataType.pacc_election.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Disbursed Money"
            } else if (
                [
                    DjangIO.app.models.QuorumDataType.supporter.value,
                    DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value,
                ].includes(args.quorumDataType.value)
            ) {
                return "Has Contributed"
            }
        }
        const HasContributedFilter = class TransactionHasContributedFilter extends Component {
            static defaultProps = {
                filterComponent: toggleGenericFilter,
                falseText: "No",
                filterKey: "",
                isNullable: true,
                trueText: "Yes",
                uniqueFilterId: hasContributedId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} displayLabel={getDisplayLabelHasContributed()} />
            }
        }

        const TransactionFilter = class TransactionFilter extends Component {
            static defaultProps = {
                filterComponent: searchifySelectGenericFilter,
                uniqueFilterId: transactionId,
                // filterKey: "id__in",
                filterKey: "",
                searchifyFLV: PacClassicPacTransactionFilterableListView,
                selectComponent: PacClassicPacTransactionSelect,
                displayLabel: "Search Transactions",
                searchifyPermanentFilter: {
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value
                        ? {
                              pac_classic_pac_account__pac_classic_individual__supporter__isnull: false,
                          }
                        : {}),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_organization.value
                        ? { pac_classic_pac_account__pac_classic_pac_organization__isnull: false }
                        : {}),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.person.value
                        ? { pac_classic_pac_account__pac_classic_pac_organization__legislator_id__isnull: false }
                        : {}),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_election.value
                        ? { pac_classic_election__isnull: false }
                        : {}),
                },
                maxSearchifySelections: Infinity,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const HorizontalRuleFilter = class TransactionHorizontalRuleFilter extends Component {
            static defaultProps = {
                filterComponent: hrGenericFilter,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const LabelFilter = class TransactionLabelFilter extends Component {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                    ? {
                          displayLabel: `Search for ${
                              args.quorumDataType.plural
                          } with an Aggregate ${getDisplayLabelExtraTransactionType()} Total`,
                      }
                    : {}),
                invisible: true,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const LabelNewContributorFilter = class TransactionLabelNewContributorFilter extends Component {
            static defaultProps = {
                filterComponent: enumGenericFilter,
                displayLabel: "Search for New Contributors",
                invisible: true,
                uniqueFilterId: labelNewContributorId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const PacClassicPacReportCodeFilter = class TransactionPacLimitTypeFilter extends Component {
            static defaultProps = {
                filterComponent: enumStringGenericFilter,
                displayLabel: "PAC Report Code",
                enumItems: DjangIO.app.pac_classic.types.PacClassicPacReportCode.region_supported_items(),
                // filterKey: "pac_report_code__in",
                filterKey: "",
                helpText: "Filter by the type of Transaction, e.g. Contribution to Individual",
                selectComponent: PacClassicPacReportCodeSelect,
                sortBy: enumLabelSort,
                uniqueFilterId: pacReportCodeId,
            }

            render() {
                const FilterComponent = this.props.filterComponent
                return <FilterComponent {...this.props} />
            }
        }

        const amountColumn =
            args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                ? "amount"
                : "sum"

        const getSubFilters = () => {
            const canViewDisbursementsOrReceipts = Userdata.can_view_pac_receipts || Userdata.can_view_pac_disbursements

            const canViewBothDisbursementsAndReceipts =
                Userdata.can_view_pac_receipts && Userdata.can_view_pac_disbursements

            const isContactDatasetWithViewReceipts =
                args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value &&
                Userdata.can_view_pac_receipts

            const isPacClassicPacOrganizationDatasetWithViewDisbursement =
                args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_organization.value &&
                Userdata.can_view_pac_disbursements

            if (
                canViewBothDisbursementsAndReceipts ||
                isContactDatasetWithViewReceipts ||
                isPacClassicPacOrganizationDatasetWithViewDisbursement
            ) {
                return [
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [HasContributedFilter, HorizontalRuleFilter, LabelFilter]
                        : []),
                    [DateGteFilter, DateLteFilter],
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value
                        ? [
                              {
                                  label: LabelNewContributorFilter,
                                  subfilters: [DateNewContributorGteFilter, DateNewContributorLteFilter],
                              },
                          ]
                        : []),
                    {
                        label: AmountLabelFilter,
                        subfilters: [AmountGteFilter, AmountLteFilter],
                    },
                    BankAccountFilter,
                    ...([
                        DjangIO.app.models.QuorumDataType.person.value,
                        DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
                    ].includes(args.quorumDataType.value)
                        ? [ElectionFilter]
                        : []),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [
                              // TODO: add PacClassicBatch table
                              // BatchFilter,
                              ReferenceNumberFilter,
                          ]
                        : []),
                    MethodTypeFilter,
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [PayrollCycleFilter]
                        : []),
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [HorizontalRuleFilter, TransactionFilter]
                        : []),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [PacClassicPacReportCodeFilter]
                        : []),
                ]
            }

            if (canViewDisbursementsOrReceipts) {
                return [
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? [TransactionFilter]
                        : []),
                ]
            }

            return []
        }

        return {
            ...args,
            allFilterKeys: ["associated_transactions"],
            filterComponent: multiGenericFilter,
            uniqueFilterId,
            serializationKey: serializationKey,
            // actually defined in
            // shared/search/containers/FilterGroup/SupporterPACFilterGroup.js
            // connectedFilterGroup => defaultProps => filterKeyMap
            filterKey: "associated_transactions",
            subfilters: getSubFilters(),
            computeFilterKeyFromSubfilters: (filters) => "associated_transactions",
            // any time we make changes to filterKeys in computeFilterValueFromSubfilters/computeSubfilterValuesFromParent,
            // we must always also update qdt_allowed_filter_keys in
            // app/pac_classic/models/pac_classic_queryset_mixin.py PacClassicTransactionQuerySetMixin associated_transactions
            computeFilterValueFromSubfilters: (filters) => {
                const hasContributed = filters.get(hasContributedId)
                const dateGte = filters.get(dateGteId)
                const dateLte = filters.get(dateLteId)
                const dateNewContributorGte = filters.get(dateNewContributorGteId)
                const dateNewContributorLte = filters.get(dateNewContributorLteId)
                const amountGte = filters.get(amountGteId)
                const amountLte = filters.get(amountLteId)
                const bankAccount = filters.get(bankAccountId)
                const election = filters.get(electionId)
                const methodType = filters.get(methodTypeId)
                const batch = filters.get(batchId)
                const referenceNumber = filters.get(referenceNumberId)
                const payrollCycle = filters.get(payrollCycleId)
                const transaction = filters.get(transactionId)
                const limitType = filters.get(limitTypeId)
                const pacReportCode = filters.get(pacReportCodeId)

                if (
                    !hasContributed &&
                    !dateGte &&
                    !dateLte &&
                    !dateNewContributorGte &&
                    !dateNewContributorLte &&
                    !amountGte &&
                    !amountLte &&
                    !bankAccount &&
                    !election &&
                    !methodType &&
                    !batch &&
                    !referenceNumber &&
                    !payrollCycle &&
                    !transaction &&
                    !limitType &&
                    !pacReportCode
                ) {
                    return undefined
                }

                const params = {}

                if (args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value) {
                    if (hasContributed) {
                        params.has_contributed = hasContributed
                    }
                    if (transaction) {
                        params.id__in = transaction
                    }
                }

                if (dateGte) {
                    params.transaction_date__gte = dateGte
                }
                if (dateLte) {
                    params.transaction_date__lte = dateLte
                }

                if (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value) {
                    if (dateNewContributorGte) {
                        params.transaction_date_new_contributor__gte = dateNewContributorGte
                    }
                    if (dateNewContributorLte) {
                        params.transaction_date_new_contributor__lte = dateNewContributorLte
                    }
                }

                if (amountGte) {
                    params[`${amountColumn}__gte`] = amountGte
                }
                if (amountLte) {
                    params[`${amountColumn}__lte`] = amountLte
                }

                if (bankAccount) {
                    params.pac_classic_bank_account_id__in = bankAccount
                }

                if (
                    [
                        DjangIO.app.models.QuorumDataType.person.value,
                        DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
                    ].includes(args.quorumDataType.value)
                ) {
                    if (election) {
                        params.pac_classic_election_id__in = election
                    }
                }

                if (methodType) {
                    params.transaction_method__in = methodType
                }

                if (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value) {
                    if (batch) {
                        params.pac_batch_id__in = batch
                    }

                    if (referenceNumber) {
                        params.reference_number__in = referenceNumber
                    }

                    if (payrollCycle) {
                        params.pac_classic_pac_account__payroll_cycle__in = payrollCycle
                    }

                    if (pacReportCode) {
                        params.pac_report_code__in = pacReportCode
                    }
                }

                if (args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_organization.value) {
                    if (limitType) {
                        params.pac_classic_pac_account__pac_limit_type__in = limitType
                    }
                }

                return JSON.stringify(params)
            },
            computeSubfilterValuesFromParent: (filterKey, value) => {
                const data = JSON.parse(value)

                return {
                    ...(args.quorumDataType.value !== DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? {
                              [hasContributedId]: data.has_contributed,
                              [transactionId]: data.id__in,
                          }
                        : {}),
                    [dateGteId]: data.transaction_date__gte,
                    [dateLteId]: data.transaction_date__lte,
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.supporter.value
                        ? {
                              [dateNewContributorGteId]: data.transaction_date_new_contributor__gte,
                              [dateNewContributorLteId]: data.transaction_date_new_contributor__lte,
                          }
                        : {}),
                    [amountGteId]: data[`${amountColumn}__gte`],
                    [amountLteId]: data[`${amountColumn}__lte`],
                    [bankAccountId]: data.pac_classic_bank_account_id__in,
                    ...([
                        DjangIO.app.models.QuorumDataType.person.value,
                        DjangIO.app.models.QuorumDataType.pacc_pac_organization.value,
                    ].includes(args.quorumDataType.value)
                        ? {
                              [electionId]: data.pac_classic_election_id__in,
                          }
                        : {}),
                    [methodTypeId]: data.transaction_method__in,
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_transaction.value
                        ? {
                              [batchId]: data.pac_batch_id__in,
                              [referenceNumberId]: data.reference_number__in,
                              [payrollCycleId]: data.pac_classic_pac_account__payroll_cycle__in,
                              [pacReportCodeId]: data.pac_report_code__in,
                          }
                        : {}),
                    ...(args.quorumDataType.value === DjangIO.app.models.QuorumDataType.pacc_pac_organization.value
                        ? {
                              [limitTypeId]: data.pac_classic_pac_account__pac_limit_type__in,
                          }
                        : {}),
                }
            },
        }
    }

    const defaultProps = getDefaultProps()
    class UnconnectedPacClassicPacTransactionAmountFilter extends Component {
        static get defaultProps() {
            return defaultProps
        }

        applyFilterModificationsForHasContributed(filter) {
            const defaultProps = filter?.defaultProps
            const defaultUniqueFilterId = defaultProps?.uniqueFilterId

            const overrideDefaultPropsForSelect = (label) => {
                filter.defaultProps.dataTypeLabel = label
                filter.defaultProps.displayLabel = label
                // special case:
                // for whatever reason, just overriding the dataTypeLabel displayLabel
                // in the defaultProps of a Select component doesn't do anything
                // even though the defaultProps Object is not frozen
                // TODO: figure out why this is _actually_ happening
                filter.defaultProps = Object.assign({}, filter.defaultProps)
            }
            const resetDefaultPropsLabels = ({ ignoreHasContributed }) => {
                switch (defaultUniqueFilterId) {
                    case hasContributedId:
                        if (!ignoreHasContributed) {
                            filter.defaultProps.displayLabel = "Has Contributed"
                        }
                        break
                    case dateGteId:
                        filter.defaultProps.displayLabel = "Date From"
                        break
                    case dateLteId:
                        filter.defaultProps.displayLabel = "Date To"
                        break
                    case labelAmountId:
                        filter.defaultProps.displayLabel = "Total Amount"
                        break
                    case bankAccountId:
                        overrideDefaultPropsForSelect("Bank Account")
                        break
                    case methodTypeId:
                        filter.defaultProps.displayLabel = "Payment Methods"
                        break
                    case transactionId:
                        overrideDefaultPropsForSelect("Search Transactions")
                        break
                    case dateNewContributorGteId:
                        filter.defaultProps.displayLabel = "First Contribution"
                        break
                    case dateNewContributorLteId:
                        filter.defaultProps.displayLabel = "Last Contribution"
                        break
                    case electionId:
                        overrideDefaultPropsForSelect("Search Elections")
                        break
                    case batchId:
                        overrideDefaultPropsForSelect("Batch")
                        break
                    case referenceNumberId:
                        filter.defaultProps.displayLabel = "Reference Number"
                        break
                    case payrollCycleId:
                        filter.defaultProps.displayLabel = "Contact Payroll Frequency"
                        break
                    case limitTypeId:
                        filter.defaultProps.displayLabel = "PAC Limit Type"
                        break
                    case pacReportCodeId:
                        filter.defaultProps.displayLabel = "PAC Report Code"
                        break
                    default:
                        break
                }
            }

            if (this.props.filterValue) {
                const filterValue = JSON.parse(this.props.filterValue)

                if (defaultUniqueFilterId === hasContributedId) {
                    if (filterValue.has_contributed === "true") {
                        filter.defaultProps.displayLabel = "Has Matching Transactions"
                        resetDefaultPropsLabels({ ignoreHasContributed: true })
                    } else if (filterValue.has_contributed === "false") {
                        filter.defaultProps.displayLabel = "No Matching Transactions"
                    } else {
                        // if any other filter contains a value,
                        // (i.e., if this.props.filterValue is truthy/non-empty)
                        // then we should display "Has Transactions Matching" instead of "Has Contributed"
                        filter.defaultProps.displayLabel = "Has Matching Transactions"
                        resetDefaultPropsLabels({ ignoreHasContributed: true })
                    }
                } else {
                    if (filterValue.has_contributed === "true" || !filterValue.has_contributed) {
                        resetDefaultPropsLabels({ ignoreHasContributed: true })
                    }
                }

                if (filterValue.has_contributed === "false") {
                    switch (defaultUniqueFilterId) {
                        case dateGteId:
                            filter.defaultProps.displayLabel = "Exclude Date From"
                            break
                        case dateLteId:
                            filter.defaultProps.displayLabel = "Exclude Date To"
                            break
                        case labelAmountId:
                            filter.defaultProps.displayLabel = "Excluded Total Amount"
                            break
                        case bankAccountId:
                            overrideDefaultPropsForSelect("Exclude Bank Account")
                            break
                        case methodTypeId:
                            filter.defaultProps.displayLabel = "Exclude Payment Methods"
                            break
                        case transactionId:
                            overrideDefaultPropsForSelect("Exclude Search Transactions")
                            break
                        case dateNewContributorGteId:
                            filter.defaultProps.displayLabel = "Exclude First Contribution"
                            break
                        case dateNewContributorLteId:
                            filter.defaultProps.displayLabel = "Exclude Last Contribution"
                            break
                        case electionId:
                            overrideDefaultPropsForSelect("Exclude Search Elections")
                            break
                        case batchId:
                            overrideDefaultPropsForSelect("Exclude Batch")
                            break
                        case referenceNumberId:
                            filter.defaultProps.displayLabel = "Exclude Reference Number"
                            break
                        case payrollCycleId:
                            filter.defaultProps.displayLabel = "Exclude Contact Payroll Frequency"
                            break
                        case limitTypeId:
                            filter.defaultProps.displayLabel = "Exclude PAC Limit Type"
                            break
                        case pacReportCodeId:
                            filter.defaultProps.displayLabel = "Exclude PAC Report Code"
                            break
                        default:
                            break
                    }
                }
            } else {
                resetDefaultPropsLabels({})
            }
        }

        render() {
            const FilterComponent = this.props.filterComponent
            return (
                <FilterComponent
                    {...this.props}
                    subfilters={this.props.subfilters
                        .map((subfilter) => {
                            const processFilter = (filter) => {
                                if (
                                    [dateNewContributorGteId, dateNewContributorLteId, labelNewContributorId].includes(
                                        filter.defaultProps.uniqueFilterId,
                                    ) &&
                                    ((this.props.filterValue && !this.props.filterValue.includes("transaction_date")) ||
                                        !this.props.filterValue ||
                                        // TODO: remove this once necessary UX changes are made
                                        !isFeatureEnabled("ff_qpac_new_contributors"))
                                ) {
                                    return false
                                }

                                return filter
                            }

                            if (Array.isArray(subfilter)) {
                                return subfilter
                                    .map((subsubfilter) => {
                                        this.applyFilterModificationsForHasContributed(subsubfilter)
                                        return processFilter(subsubfilter)
                                    })
                                    .filter((subfilter) => subfilter)
                            } else if (typeof subfilter === "object") {
                                this.applyFilterModificationsForHasContributed(subfilter.label)

                                return {
                                    label: processFilter(subfilter.label),
                                    subfilters: subfilter.subfilters
                                        .map((subsubfilter) => {
                                            this.applyFilterModificationsForHasContributed(subsubfilter)
                                            return processFilter(subsubfilter)
                                        })
                                        .filter((subfilter) => subfilter),
                                }
                            } else {
                                this.applyFilterModificationsForHasContributed(subfilter)
                                return processFilter(subfilter)
                            }
                        })
                        .filter((subfilter) => (Array.isArray(subfilter) ? subfilter.length : subfilter))}
                />
            )
        }
    }

    const PacClassicPacTransactionAmountFilter = connect(
        createStructuredSelector({
            filterValue: selectFilterValue,
        }),
    )(UnconnectedPacClassicPacTransactionAmountFilter)
    PacClassicPacTransactionAmountFilter.defaultProps = defaultProps

    return PacClassicPacTransactionAmountFilter
}

// PacClassicPacTransactionDetailsFilterGroup
export class PacClassicPacTransactionPACCIdFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: textGenericFilter,
            uniqueFilterId: "pacClassicPacTransactionPACCIdFilter",
            filterKey: "pac_transaction_id",
            displayLabel: "Search by Transaction ID (serial number)",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PacClassicPacTransactionIsVoidFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "pacClassicPacTransactionIsVoidFilter",
        filterKey: "is_void",
        trueText: "Void",
        falseText: "Not Void",
        displayLabel: "Is Void",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PacClassicPacTransactionIsVoidDatePickerStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "pacClassicPacTransactionIsVoidDatePickerStartFilter",
        filterKey: "void_date__gte",
        displayLabel: "Void Start Date",
        helpText: "Transactions voided after this date. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PacClassicPacTransactionIsVoidDatePickerEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "pacClassicPacTransactionIsVoidDatePickerEndFilter",
        filterKey: "void_date__lte",
        displayLabel: "Void End Date",
        helpText: "Transactions voided before this date. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PacClassicPacTransactionIsMemoEntryFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "pacClassicPacTransactionIsMemoEntryFilter",
        filterKey: "is_memo_entry",
        displayLabel: "Is Memo Only",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PacClassicPacTransactionIsReconciledFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "pacClassicPacTransactionIsReconciledFilter",
        filterKey: "is_cleared",
        trueText: "Reconciled",
        falseText: "Not Reconciled",
        displayLabel: "Is Reconciled",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// PacClassicPacTransactionSupporterFilterGroup
export class PacClassicPacTransactionSupporterFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "Contacts",
            filterKey: "transaction_supporter",
            searchifyFLV: SupporterFilterableListView,
            selectComponent: ContactSelect,
            uniqueFilterId: "pacClassicPacTransactionSupporterFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// PacClassicPacTransactionPacOrganizationFilterGroup
export class PacClassicPacTransactionPacOrganizationFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "PAC Organization (PAC)",
            filterKey: "transaction_pac_organization",
            searchifyFLV: PacClassicPacOrganizationFilterableListView,
            selectComponent: PacClassicPacOrganizationSelect,
            uniqueFilterId: "pacClassicPacTransactionPacOrganizationFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// PacClassicPacTransactionOfficialFilterGroup
export class PacClassicPacTransactionOfficialFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "Official",
            filterKey: "transaction_person",
            permissions: [DjangIO.app.models.PermissionType.legislators],
            searchifyFLV: OfficialFilterableListView,
            selectComponent: OfficialSelect,
            uniqueFilterId: "pacClassicPacTransactionOfficialFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// PacClassicPacTransactionElectionFilterGroup
export class PacClassicPacTransactionElectionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "Election (PAC)",
            filterKey: "transaction_election",
            // TODO: add this FLV
            // searchifyFLV: PacClassicElectionFilterableListView
            selectComponent: PacClassicElectionSelect,
            uniqueFilterId: "pacClassicPacTransactionElectionFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// PacClassicPacTransactionOrganizationFilterGroup
export class PacClassicPacTransactionOrganizationFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            dataTypeLabel: "Organization (PAC)",
            filterKey: "transaction_organization",
            // TODO: add this FLV
            // searchifyFLV: PacClassicOrganizationFilterableListView
            selectComponent: PacClassicOrganizationSelect,
            uniqueFilterId: "pacClassicPacTransactionOrganizationFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
